import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { PaymentTypesMsiRedux } from '../Redux/PaymentTypesMsiRedux'

const paymentTypesMsiCrudObservable = createCRUDObservable({
    mainRedux: PaymentTypesMsiRedux,
    reduxPath: 'payment_types_msi',
    dataHandlers: {
        get: response => response.data.data,
    },
})

export const paymentTypesMsiObservers = Object.assign({}, paymentTypesMsiCrudObservable.observers, {})

export const paymentTypesMsiEpic = combineEpics(
    paymentTypesMsiCrudObservable.epic,
)


// WEBPACK FOOTER //
// ./src/Data/Observables/PaymentTypesMsiObservable.js